import React from 'react'
import AddFee from './AddFee';
import { confirmAlert } from 'react-confirm-alert';
import { withAllContexts } from '../../../AllContextsWrapper';
import { enqueueSnackbar } from 'notistack';
import { Trash2, ShoppingCart, AlertCircle } from 'lucide-react';

const Fees = ({ reservation, app, socketIO }) => {
  const deleteFeeConfirmation = (feeId) => {
    confirmAlert({
      title: 'Zmazanie poplatku',
      message: 'Naozaj chceš vymazať tento poplatok?',
      buttons: [
        {
          label: 'Zrušiť'
        },
        {
          label: 'Zmazať',
          onClick: () => deleteFee(feeId)
        }
      ]
    });
  }

  const deleteFee = (feeId) => {
    socketIO.socket.emit('fee:delete', feeId, (response) => {
      if (response.success === true) {
        app.functions.updateCurrReservation(reservation.id);
        app.functions.updateMainCalendar();
        enqueueSnackbar("Poplatok úspešne odstránený", { variant: "success" });
      } else {
        enqueueSnackbar("Poplatok sa nepodarilo odstrániť", { variant: "error" });
      }
    });
  }

  const fees = reservation.Fees || [];

  const isCamping = app.state.activeCalendar?.type === 'accommodation';
  const primaryBgClass = isCamping ? "bg-taborisko-pine/10 text-taborisko-pine" : "bg-splavma-teal/10 text-splavma-teal";
  const primaryTextClass = isCamping ? "text-taborisko-pine" : "text-splavma-teal";
  const rowHoverClass = isCamping ? "hover:bg-taborisko-pine/5" : "hover:bg-splavma-teal/5";

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <div className={`p-2 rounded-xl ${primaryBgClass}`}>
          <ShoppingCart className="w-5 h-5" />
        </div>
        <h2 className="text-lg font-bold text-gray-900 uppercase tracking-wide">Poplatky a služby</h2>
      </div>

      {fees.length > 0 ? (
        <div className="space-y-4 mb-8">
          {/* Desktop Table View */}
          <div className="hidden md:block bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-50/50 border-b border-gray-100 text-[10px] font-bold text-gray-500 uppercase tracking-widest">
                    <th className="px-6 py-4">Kategória</th>
                    <th className="px-6 py-4">Popis</th>
                    <th className="px-6 py-4 text-right">Množstvo</th>
                    <th className="px-6 py-4 text-right">Jedn. Cena</th>
                    <th className="px-6 py-4 text-right">Spolu</th>
                    <th className="px-6 py-4 text-center">Pridal</th>
                    <th className="px-6 py-4 w-10"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {fees.map((fee, key) => (
                    <tr key={key + "_fee"} className={`group ${rowHoverClass} transition-colors`}>
                      <td className="px-6 py-4 text-sm font-bold text-gray-900">
                        {app.functions.getDisplayText(fee.category)}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-600">
                        {fee.description || '-'}
                      </td>
                      <td className="px-6 py-4 text-sm font-bold text-gray-600 text-right">
                        {fee.amount}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-500 text-right">
                        {fee.price} €
                      </td>
                      <td className={`px-6 py-4 text-sm font-black text-right ${primaryTextClass}`}>
                        {(fee.price * fee.amount).toFixed(2)} €
                      </td>
                      <td className="px-6 py-4 text-xs font-bold text-gray-500 text-center uppercase tracking-wider">
                        <span className="bg-gray-100 px-2 py-1 rounded-md">
                          {socketIO.usersShort[fee.added_by] || '?'}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() => deleteFeeConfirmation(fee.id)}
                          className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-gray-50/80 border-t border-gray-100">
                  <tr>
                    <td colSpan="4" className="px-6 py-5 text-sm font-bold text-gray-900 uppercase tracking-widest text-right">
                      Celkom:
                    </td>
                    <td className={`px-6 py-5 text-lg font-black text-right ${primaryTextClass}`}>
                      {fees.reduce((acc, fee) => acc + (fee.price * fee.amount), 0).toFixed(2)} €
                    </td>
                    <td colSpan="2"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden space-y-2">
            {fees.map((fee, key) => (
              <div key={key + "_fee_mobile"} className="bg-white rounded-xl p-3 border border-gray-100 shadow-sm relative group">
                <div className="flex justify-between items-start mb-1">
                  <div className="flex-1 min-w-0 pr-8">
                    <span className="text-[9px] font-black uppercase tracking-widest text-gray-400 block">
                      {app.functions.getDisplayText(fee.category)}
                    </span>
                    <h4 className="text-xs font-bold text-gray-900 truncate">{fee.description || '-'}</h4>
                  </div>
                  <button
                    onClick={() => deleteFeeConfirmation(fee.id)}
                    className="p-1.5 text-red-500 bg-red-50 rounded-lg flex-shrink-0"
                  >
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                </div>
                
                <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-50">
                  <div className="text-[10px] font-medium text-gray-500">
                    <span className="font-bold text-gray-700">{fee.amount}x</span> {fee.price}€
                  </div>
                  <div className={`text-base font-black ${primaryTextClass}`}>
                    {(fee.price * fee.amount).toFixed(2)}€
                  </div>
                </div>
                
                <div className="absolute top-3 right-10 text-[8px] font-bold text-gray-300 uppercase bg-gray-50/50 px-1 py-0.5 rounded">
                  {socketIO.usersShort[fee.added_by] || '?'}
                </div>
              </div>
            ))}
            
            {/* Mobile Total */}
            <div className="bg-gray-900 rounded-xl p-3 flex justify-between items-center text-white shadow-md">
              <span className="text-[10px] font-bold uppercase tracking-widest opacity-70">Spolu</span>
              <span className="text-lg font-black">
                {fees.reduce((acc, fee) => acc + (fee.price * fee.amount), 0).toFixed(2)}€
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center mb-8 shadow-sm">
          <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-6 h-6 text-gray-400" />
          </div>
          <h3 className="text-gray-900 font-bold mb-1 uppercase tracking-wide">Žiadne poplatky</h3>
          <p className="text-gray-500 text-sm font-medium">Pre túto rezerváciu zatiaľ neboli pridané žiadne ďalšie poplatky.</p>
        </div>
      )}

      <AddFee reservation={reservation} />
    </div>
  );
}

export default withAllContexts(Fees);
